import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.5 13.5h-5V18h5v-4.5z",
    opacity: ".2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.805 14.054H10.25L13.168 9l-1.05 3.947h1.554L10.754 18l1.051-3.946z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M16.75 19.25a1 1 0 01-1 1h-7.5a1 1 0 01-1-1V7.75a1 1 0 011-1h7.5a1 1 0 011 1v11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.5 13.5h-5V18h5v-4.5z",
    opacity: ".2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.805 14.054H10.25L13.168 9l-1.05 3.947h1.554L10.754 18l1.051-3.946z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "1.5",
    d: "M9.5 3.75h5"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M33.5 38.5a2 2 0 01-2 2h-15a2 2 0 01-2-2v-23a2 2 0 012-2h15a2 2 0 012 2v23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29 27H19v9h10v-9z",
    opacity: ".2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.61 28.108H20.5L26.336 18l-2.102 7.894h3.11L21.508 36l2.102-7.892z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeWidth: "3",
    d: "M19 7.5h10"
  }))
};
export var BatteryChargingLow = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});